module.exports = __webpack_public_path__ + "img/heartstopper-volume-one.7664d00b.png";